import * as React from 'react';
var ExpandedRowContext = /*#__PURE__*/React.createContext(null);
export default ExpandedRowContext;